import {REGISTRY_SINGLETON} from '../../scenes/Registry';
import {playSupplyRecruitEffects} from '../../scenes/playUnitRecruitmentEffects';
import {selectIsCityCaptureAnimationPlaying} from '../reducers/privateStateReducer/selectors';
import {selectUnits} from '../reducers/sharedStateReducer/selectors';
import {checkIfSupplyRecruitHiddenFromViewer} from '../../utils/unit/checkIfSupplyRecruitHiddenFromViewer';

/**
 * Новобранец крысолюдов за снабжение проявляется на ферме здесь: найм приходит и с кнопки
 * (RatmenRecruitmentToolbar), и из авто-раздачи в начале фазы (executePhaseAutoActions),
 * и с сервера, и только стор видит их все.
 *
 * Чужого новобранца не видно до итога фазы: он проявится, когда встанет на поле (см.
 * GameScene.playSupplyRecruitsReveal). Во время облета захваченных городов камера занята:
 * снабжение и так показывается после него, поэтому отряд просто встанет.
 *
 * Стоит в конце цепочки, как и удары боя: отброшенный гейтами экшен сюда не доходит.
 */
export const createSupplyRecruitAnimationMiddleware = ({
  getHexGridRenderer,
  getSoundManager,
  play = playSupplyRecruitEffects,
}) => (store) => (next) => (action) => {
  if (action?.type !== 'RECRUIT_UNIT' || !action.payload?.isRatmenForSupplyRecruitment) {
    return next(action);
  }

  const result = next(action);

  const state = store.getState();
  const unit = (selectUnits(state) || []).find(({id}) => id === action.payload.unitId);
  if (unit && !checkIfSupplyRecruitHiddenFromViewer(unit, state) && !selectIsCityCaptureAnimationPlaying(state)) {
    try {
      play(store, getHexGridRenderer(), getSoundManager(), {unit, isPaced: Boolean(action._fromServer)});
    } catch (error) {
      // Анимация — украшение: ее поломка не должна ронять диспатч
      console.warn('[SupplyRecruit] не удалось показать найм за снабжение', error);
    }
  }

  return result;
};

const supplyRecruitAnimationMiddleware = createSupplyRecruitAnimationMiddleware({
  getHexGridRenderer: () => REGISTRY_SINGLETON.getHexGridRenderer(),
  getSoundManager: () => REGISTRY_SINGLETON.getSoundManager(),
});

export default supplyRecruitAnimationMiddleware;
